
































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import Util from '@/lib/util'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class ProductListRequest extends PageRequest {
        createTime?: Date;
        endTime?: Date;
        name: string;
        skuCode: string;
        productId: string;
        warehouseId?: number;
        status?: number;
        //constructor() {
        //    super();
        //    this.importType = null;

        //    this.implementKind = null;
        //}
    }

    @Component({
        name:"backdistributionproduct",
    })
    export default class ImportExcel extends AbpBase {
        productstatus = Enums.getEnum(Enums.DistributionProductStatus, true);
        storeaddressList: Array<storeaddressInfo> = [];
        selectstoreaddressList: Array<storeaddressInfo> = [];
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        selectwId: number;
        rate: number=1;

        pagerequest: ProductListRequest = new ProductListRequest();
        createTime: Date[] = [];
        get list() {
            return this.$store.state.backdistributionproduct.list;
        };
        get loading() {
            return this.$store.state.backdistributionproduct.loading;
        }
        get pageSizeOpts() {
            return this.$store.state.backdistributionproduct.pageSizeOpts;
        }
        pageChange(page: number) {
            this.$store.commit('backdistributionproduct/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backdistributionproduct/setPageSize', pagesize);
            this.getpage();
        }
        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
             if (this.createTime.length > 0) {
                this.pagerequest.createTime = this.createTime[0];
            }
            if (this.createTime.length > 1) {
                this.pagerequest.endTime = this.createTime[1];
            }
            await this.$store.dispatch({
                type: 'backdistributionproduct/getAll',
                data: this.pagerequest
            });

        }
        async changewarehouse(val: number) {
            this.uploadURL = appconst.remoteServiceBaseUrl + "api/services/app/DistributionProduct/UploadProduct?Wid=" + val + "&rate=" + this.rate;
        }

        async changerate(val: number) {
            this.uploadURL = appconst.remoteServiceBaseUrl + "api/services/app/DistributionProduct/UploadProduct?Wid=" + this.selectwId + "&rate=" + this.rate;
        }
        async batchupshelf() {
           this.operation(0);
        }

        async batchdownshelf() {
            this.operation(1);
        }

        async operation(status: number) {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var statuName = Enums.DistributionProductStatus.filter(function (item) { return item.value == status })[0].name;
            this.$Modal.confirm({
                title: "更新产品状态", content: "确认批量将产品状态处理为" + statuName + "？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].productId);
                    }
                    await this.$store.dispatch({
                        type: 'backdistributionproduct/OpreationProduct',
                        data: { Ids: ids, Status: status }
                    });
                    this.getpage();

                }
            });
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true }); 
            this.storeaddressList.push(a);
            this.selectstoreaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });


        }
        async searchPage() {
            this.$store.state.backdistributionproduct.currentPage=1;
            this.getpage();
        }
        get pageSize() {
            return this.$store.state.backdistributionproduct.pageSize;
        }
        get totalCount() {
            return this.$store.state.backdistributionproduct.totalCount;
        }
        get currentPage() {
            return this.$store.state.backdistributionproduct.currentPage;
        }
        uploadURL: string = "";

        jumpage(data: any) {
            //var url = "http://localhost:1337/#/" + "editproductdetail/editdetail?id=" + data.productId;
            var url = "https://warehouse.qianchanchan.com/#/" + "editproductdetail/editdetail?id=" + data.productId;
            window.open(url);
        }
  

        handleSuccess(res, file) {
            if (res.success) {
                this.$Message.success('导入成功。');
            }
        }
        handleError(res, file) {
            this.$Message.error('导入失败。');
        }
        columns = [
            {
                type: 'selection',
                width: 60,
                align: 'center',
                fixed: 'left',

            },
           {
               title: '仓库名',
               key: 'warehouseName',
               width: 150,
     
           }, {
            title: '产品Id',
               key: 'productId',
            width: 150,
        },
           {
            title: '标题',
               key: 'title',
            width: 300,
           }, {
               title: '图片',
               key: 'mainImgUrl',
               width: 150,
               render: (h: any, params: any) => {
                   if (params.row.mainImgUrl) {
                       var url = params.row.mainImgUrl;
                       return h('img', {
                           style: {
                               width: "50px",
                               height: "50px",
                               verticalAlign: "middle"
                           },
                           attrs: {
                               src: url,
                               preview: "dp_" + params.row.id,
                               "preview-text": params.row.id
                           }
                       });

                   } else {
                       return h('span', "");
                   }
               }
           }, {
               title: '价格',
               key: 'price',
               width: 120,
           },{
            title: '库存',
               key: 'stock',
            width: 120,
            },
            //{
            //title: '来源',
            //width: 142,
            //   key: 'productCollectionSource',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.ProductCollectionSource.filter(function (item) { return item.value == params.row.productCollectionSource })[0].name);
            //}
            //},
            {
            title: '状态',
            width: 142,
               key: 'distributionProductStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.DistributionProductStatus.filter(function (item) { return item.value == params.row.distributionProductStatus })[0].name);
            }
        }, {
            title: '创建时间',
               key: 'creationTime',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
            }
           }, {
               title: '修改时间',
               key: 'lastModificationTime',
               width: 150,
               render: (h: any, params: any) => {
                   if (params.row.lastModificationTime != null) {
                       return h('span', DateUtils.formatLongDate(new Date(params.row.lastModificationTime)));
                   }
               }
            },
            {
                title: '操作',
                width: 100,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;

                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '68px',
                                height: '30px',
                            //    display: (packageStatus == "未收货" || packageStatus == "已收货" && orderStatus == "正常") && productOrderStatusName != "已取消" ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                     _this.jumpage(data);
                                }
                            }

                        }, "编辑")
                    ]);
                }
            }
      
    ]

        async created() {
           // this.uploadURL = appconst.remoteServiceBaseUrl + "api/services/app/DistributionProduct/UploadProduct?Wid=" + this.selectwId + "&rate=" + this.rate;
            this.getpage();
            this.getData();
        }
        /**按钮显示内容 */
        //  @Prop({ type: String, default: "" }) btnTitle: String;
    }
